import { ModelSnippetFn } from '../types';

export const text: ModelSnippetFn = (props) => `
from clarifai.client.model import Model

prompt = "What's the future of AI?"

model_url="https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}"
model_prediction = Model(url=model_url, pat="${props.pat}"${
  props.deploymentId ? `, deployment_id="${props.deploymentId}"` : ''
}).predict_by_bytes(prompt.encode())

print(model_prediction.outputs)
`;

export const image: ModelSnippetFn = (props) => `
from clarifai.client.model import Model

image_url = "https://s3.amazonaws.com/samples.clarifai.com/featured-models/image-captioning-statue-of-liberty.jpeg"

model_url = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}"
model_prediction = Model(url=model_url, pat="${props.pat}"${
  props.deploymentId ? `, deployment_id="${props.deploymentId}"` : ''
}).predict_by_url(image_url)

print(model_prediction.outputs)

`;

export const audio: ModelSnippetFn = (props) => `
from clarifai.client.model import Model

audio_url = "https://s3.amazonaws.com/samples.clarifai.com/GoodMorning.wav"

model_url = "https://clarifai.com/${props.userId}/${props.appId}/models/${props.modelId}"
model_prediction = Model(url=model_url, pat="${props.pat}"${
  props.deploymentId ? `, deployment_id="${props.deploymentId}"` : ''
}).predict_by_url(audio_url)

print(model_prediction.outputs)
`;

export const video: ModelSnippetFn = (props) => `
from clarifai.client.model import Model

USER_ID = "${props.userId}"
APP_ID = "${props.appId}"
# Change these to whatever model and video URL you want to use
MODEL_ID = "${props.modelId}"
# You can also set a particular model version by specifying the  version ID
# eg: MODEL_VERSION_ID = '${props.modelVersionId}'

VIDEO_URL = "https://samples.clarifai.com/beer.mp4"
SAMPLE_MS = 2000

model = Model(user_id="clarifai", app_id="main", model_id=MODEL_ID, pat="${props.pat}"${
  props.deploymentId ? `, deployment_id="${props.deploymentId}"` : ''
})
output_config = {"sample_ms": SAMPLE_MS}  # Run inference every 2 seconds
model_prediction = model.predict_by_url(
    BEER_VIDEO_URL, input_type="video", output_config=output_config)


for frame in model_prediction.outputs[0].data.frames:
    print(f"Frame Info: {frame.frame_info} Concept: {frame.data.concepts[0].name}\n")
`;
